export default "__VITE_ASSET__DzPcpOdJ__"